import { LatitudeLongitude } from '@aloft/toolkit-shared';

import { getConfig } from '../../utils/getConfig.ts';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useMakeStreetViewStaticURL } from './useMakeStreetViewStaticURL.ts';

/** @deprecated Use {@link useMakeStreetViewStaticURL} instead */
export const makeStreetViewStaticURL = ({ latitude, longitude }: LatitudeLongitude) =>
  `https://maps.googleapis.com/maps/api/streetview?size=400x400&location=${latitude},${longitude}&key=${getConfig(
    'GOOGLE_MAPS_API_KEY',
  )}`;
